import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { JobsPage } from "@/features/jobs/JobsPage";
import { jobsQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

const search = projectSearch.extend({ mode: z.enum(["edit", "override"]).optional() });

/** Same list with the job drawer open; the URL survives reloads and sharing. */
export const Route = createFileRoute("/w/$workspace/p/$project/jobs/$jobId")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(jobsQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project, jobId } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <JobsPage
        workspace={workspace}
        project={project}
        env={s.env ?? DEFAULT_ENV}
        jobId={jobId}
        mode={s.mode ?? "detail"}
        onMode={(id, mode) => {
          if (!id || !mode)
            navigate({
              to: "/w/$workspace/p/$project/jobs",
              params: { workspace, project },
              search: (prev) => ({ env: prev.env }),
            });
          else if (mode === "new")
            navigate({
              to: "/w/$workspace/p/$project/jobs",
              params: { workspace, project },
              search: (prev) => ({ env: prev.env, mode: "new" }),
            });
          else
            navigate({
              to: "/w/$workspace/p/$project/jobs/$jobId",
              params: { workspace, project, jobId: id },
              search: (prev) => ({ env: prev.env, mode: mode === "detail" ? undefined : mode }),
            });
        }}
      />
    );
  },
});
